export const consultedCasesConstants = {
    consultComplete: "consult complete",
    consultCompleteNoRx: "consult complete no rx",
};